import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { AlertTriangle, CheckCircle2, Loader2, Send } from "lucide-react";
import { API } from "../../config";

const headers = () => ({ "X-Admin-Token": localStorage.getItem("admin_token") || "" });
const eur = (v) => `€${Number(v).toLocaleString("sk-SK", { maximumFractionDigits: 2 })}`;

export const FunnelLossAlert = () => {
  const [rep, setRep] = useState(null);
  const [sending, setSending] = useState(false);

  useEffect(() => {
    axios.get(`${API}/admin/funnels/loss-alert`, { headers: headers() }).then((r) => setRep(r.data)).catch(() => setRep({ rows: [], error: true }));
  }, []);

  const send = async () => {
    setSending(true);
    try {
      const r = await axios.post(`${API}/admin/funnels/loss-alert/send`, {}, { headers: headers() });
      toast.success(r.data.sent ? "Upozornenie odoslané na váš email" : "Žiadny stratový funnel — email sa neposlal");
    } catch { toast.error("Odoslanie zlyhalo"); }
    setSending(false);
  };

  if (!rep) return null;
  const loss = rep.rows.length > 0;
  return (
    <div className={`border rounded-lg p-4 ${loss ? "border-red-200 bg-red-50" : "border-emerald-200 bg-emerald-50"}`} data-testid="funnel-loss-alert">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-center gap-2">
          {loss ? <AlertTriangle className="w-5 h-5 text-red-600" /> : <CheckCircle2 className="w-5 h-5 text-emerald-600" />}
          <p className="font-bold text-gray-900" data-testid="funnel-loss-alert-title">
            {loss ? `Stratové funnely za posledných 7 dní: −${eur(rep.total_loss_eur)}` : "Za posledných 7 dní žiadny funnel nemíňa viac, ako zarába"}
          </p>
        </div>
        <button onClick={send} disabled={sending} className="inline-flex items-center gap-2 px-3 py-1.5 text-sm font-bold bg-gray-900 text-white rounded hover:bg-gray-700 disabled:opacity-50" data-testid="funnel-loss-alert-send">
          {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Poslať teraz
        </button>
      </div>
      {loss && (
        <ul className="mt-3 space-y-1 text-sm" data-testid="funnel-loss-alert-list">
          {rep.rows.map((r) => (
            <li key={r.page} className="flex justify-between gap-3 text-gray-700">
              <span className="font-mono">{r.page}</span>
              <span>reklama {eur(r.ad_spend_eur)} · tržby {eur(r.revenue_eur)} · <b className="text-red-600">−{eur(r.loss_eur)}</b></span>
            </li>
          ))}
        </ul>
      )}
      <p className="mt-2 text-xs text-gray-500">Súhrn chodí automaticky každý pondelok o 8:00{rep.recipient_set === false ? " — chýba adresa príjemcu" : " na váš admin email"}. Mesačná cena reklamy sa rozpočíta rovnomerne na dni ({rep.from} – {rep.to}).</p>
    </div>
  );
};
